export default "__VITE_ASSET__BtLX$999__"